module.exports = __webpack_public_path__ + "img/how-it-works-1.1806b7e6.webp";